import prev from './prev.js';
import infoBig from './infoBig.js'
import warningInfo from './warningInfo.js';
import successTick from './successTick.js';
import blueTick from "./blueTick.js";
import warningOrange from './warningOrange.js';
import ExpandDrawerIcon from './expandDrawerIcon.js';
import close from './close.js';
import loaderV4 from './loaderV4.js';
import systemSetup from './systemSetup.js';
import systemSetupSuccess from './systemSetupSuccess.js';
import airDeviceQR from './airDeviceQR.js';
import auto from './auto.js';
import darkauto from './darkauto.js';
import cool from './cool.js';
import darkcool from './darkcool.js';
import heat from './heat.js';
import darkheat from './darkheat.js';
import off from './off.js';
import darkoff from './darkoff.js';
import offEnabled from './offEnabled.js';
import onEnabled from './onEnabled.js';
import heatEnabled from './heatEnabled.js';
import autoEnabled from './autoEnabled.js';
import coolEnabled from './coolEnabled.js';
import circulate from './circulate.js';
import darkcirculate from './darkcirculate.js';
import circulateEnabled from './circulateEnabled.js';
import darkcirculateEnabled from './darkcirculateEnabled.js';
import forwardArrow from './forwardArrow.js';
import Help from './help.js';
import downArrow from './downArrow.js';
import ArrowDown from './arrowDown.js';
import ArrowUp from './arrowUp.js';
import Humid from './humid.js'
import fanAutoEnabled from './fanAutoEnabled.js'
import infoIcon from './infoIcon.js'
import addIconV2 from './addIconV2.js'
import scanOff from './scanOff.js';
import scanOn from './scanOn.js';
import schedulerHandle from './schedulerHandle.js'
import setupOff from './setupOff.js';
import setupOn from './setupOn.js';
import siteOn from './siteOn.js';
import bin from './bin.js';
import plus from './plus.js';
import heatIcon from './heatIcon.js'
import coolIcon from './coolIcon.js'
import BlueCircleGauge from "./blueCircleGage";
import darkBlueCircleGage from "./darkBlueCircleGage.js";
import OrangeCircleGage from './orangeCircleGage.js';
import darkOrangeCircleGage from './darkOrangeCircleGage.js';
import serverError from './serverError.js'
import systemSetupFail from './systemSetupFail.js'
import iqAir from './iqAir.js';
import iqAirHub from './iqAirHub.js';
import circularPlus from './circularPlus.js';
import wiredConnection from './wiredConnection.js';
import zWaveConnection from './zWaveConnection.js';
import smallInfo from './smallInfo.js';
import plainClose from './plainClose.js';
import drowpDownArrow from './drowpDownArrow.js';
import closeCircle from './closeCircle.js';
import caution from './caution.js';
import TickWhiteSmall from './TickWhiteSmall.js';
import info from './info.js'
import reorder from './reorder.js'
import igWhatsInBox from './igWhatsInBox.js'
import igToolsNeeded from './igToolsNeeded.js'
import igTurnOffHvac from './igTurnOffHvac.js'
import igTakePhoto from './igTakePhoto.js'
import igHighVoltage from './igHighVoltage.js'
import igJumperWires from './igJumperWires.js'
import igJumperWiresDark from './igJumperWiresDark.js'
import igDualLabels from './igDualLabels.js'
import igDualLabelsDark from './igDualLabelsDark.js'
import igHeatPumpCheck from './igHeatPumpCheck.js'
import igPowerPlate from './igPowerPlate.js'
import igInstalling from './igInstalling.js'
import igRemoveThermostat from './igRemoveThermostat.js'
import igTrimPlate from './igTrimPlate.js'
import igMountBase from './igMountBase.js'
import igRestorePower from './igRestorePower.js'
import igCheckLed from './igCheckLed.js'
import igAttachDisplay from './igAttachDisplay.js'
import thermostatImage from './thermostatImage.js';
import IgThermostatError from './igThermostatError.js';
import IgTurnOnHvacError from './igTurnOnHvacError.js';
import IgSetupComplete from './igSetupComplete.js';
import IgRightArrow from './igRightArrow.js';
import igUnusedWire from './igUnusedWire.js';
import IgUwTakePhoto from './igUwTakePhoto.js';
import IgOpenHvac from './igOpenHvac.js';
import IgGotoHvac from './igGotoHvac.js';
import IgTerminalStrip from './igTerminalStrip.js';
import IgConnectWire1 from './igConnectWire1.js';
import IgConnectWire2 from './igConnectWire2.js';
import IgClosePanel from './igClosePanel.js';
import igPpWhatsInBox from './igPpWhatsInBox.js';
import igPpToolsNeeded from './igPpToolsNeeded.js';
import igPpSelectColors from './igPpSelectColors.js';
import igPpMountPlate from './igPpMountPlate.js';
import igPpConnectWires from './igPpConnectWires.js';
import igPpConnectWiresDark from './igPpConnectWiresDark.js';
import igPpConnectC from './igPpConnectC.js';
import igPpConnectC2 from './igPpConnectC2.js';
import igPpMountBase from './igPpMountBase.js';
import igPpInstallCable from './igPpInstallCable.js';
import igPpAttachCover from './igPpAttachCover.js';
import igPpReturnPlate from './igPpReturnPlate.js';


export default {
    prev,
    bin,
    reorder,
    plus,
    schedulerHandle,
    caution,
    TickWhiteSmall,
    infoBig,
    blueTick,
    successTick,
    warningInfo,
    warningOrange,
    ExpandDrawerIcon,
    close,
    loaderV4,
    systemSetup,
    systemSetupSuccess,
    airDeviceQR,
    auto,
    darkauto,
    cool,
    darkcool,
    heat,
    darkheat,
    off,   
    darkoff,   
    circulate,
    darkcirculate, 
    offEnabled,
    onEnabled,
    heatEnabled,
    coolEnabled,
    autoEnabled,
    circulateEnabled,
    darkcirculateEnabled,
    fanAutoEnabled,
    forwardArrow,
    Help,
    downArrow,
    ArrowDown,
    ArrowUp,
    Humid,
    infoIcon,
    addIconV2,
    scanOff,
    scanOn,
    setupOff,
    setupOn,
    siteOn,
    heatIcon,
    coolIcon,
    blueCircleGage: BlueCircleGauge,
    orangeCircleGage: OrangeCircleGage,
    darkBlueCircleGage,
    darkOrangeCircleGage,
    serverError,
    systemSetupFail,
    iqAir,
    iqAirHub,
    circularPlus,
    wiredConnection,
    zWaveConnection,
    smallInfo,
    plainClose,
    drowpDownArrow,
    closeCircle,
    info,
    igWhatsInBox,
    igToolsNeeded,
    igTurnOffHvac,
    igTakePhoto,
    igHighVoltage,
    igJumperWires,
    igDualLabels,
    igHeatPumpCheck,
    igPowerPlate,
    igInstalling,
    igRemoveThermostat,
    igTrimPlate,
    igMountBase,
    igRestorePower,
    igCheckLed,
    igAttachDisplay,
    thermostatImage,
    IgThermostatError,
    IgTurnOnHvacError,
    IgSetupComplete,
    IgRightArrow,
    igDualLabelsDark,
    igJumperWiresDark,
    igUnusedWire,
    IgUwTakePhoto,
    IgOpenHvac,
    IgGotoHvac,
    IgTerminalStrip,
    IgConnectWire1,
    IgConnectWire2,
    IgClosePanel,
    igPpWhatsInBox,
    igPpToolsNeeded,
    igPpSelectColors,
    igPpMountPlate,
    igPpConnectWires,
    igPpConnectWiresDark,
    igPpConnectC,
    igPpConnectC2,
    igPpMountBase,
    igPpInstallCable,
    igPpAttachCover,
    igPpReturnPlate
}
